<template>
    <div class="subjectboard">
        <loading ref="tLoadScreen"/>
        <header-navigation/>
        <div class="container">
            <oops ref="tOops"/>
            <subject-header :subject="'Trending'"/>
            <div class="subjectContent">
                <div class="sectionList trendingContent">
                    <trending-fourchon ref="tFourchon"/>
                    <trending-last-logs ref="tLogs"/>
                    <trending-last-status ref="tStatus"/>
                    <trending-latest-well-plans ref="tWellPlans"/>
                    <trending-latest-drill-permit ref="tDrillPermit"/>
                    <trending-latest-modify-permit ref="tModifyPermit"/>
                </div>
            </div>
        </div>
        <bottom-credits/>
    </div>
</template>

<script>
import axios from 'axios';
import { findTimeOffset } from '../helpers/Formatting.js';
import BottomCredits from '../components/BottomCredits.vue';
import HeaderNavigation from '../components/HeaderNavigation.vue';
import SubjectHeader from '../components/SubjectHeader.vue';
import TrendingFourchon from '../components/trending/TrendingFourchon.vue';
import TrendingLastLogs from '../components/trending/TrendingLastLogs.vue';
import TrendingLastStatus from '../components/trending/TrendingLastStatus.vue';
import TrendingLatestWellPlans from '../components/trending/TrendingLatestWellPlans.vue';
import TrendingLatestDrillPermit from '../components/trending/TrendingLatestDrillPermit.vue';
import TrendingLatestModifyPermit from '../components/trending/TrendingLatestModifyPermit.vue';
import Loading from '../components/Loading.vue';
import Oops from '../components/Oops.vue';

export default {
    name: 'Trending',
    components: {
        HeaderNavigation,
        BottomCredits,
        SubjectHeader,
        TrendingFourchon,
        TrendingLastLogs,
        TrendingLastStatus,
        TrendingLatestWellPlans,
        TrendingLatestDrillPermit,
        TrendingLatestModifyPermit,
        Loading,
        Oops
    },
    mounted() {
        var globv = this;
        globv.retrieveTrending();
        globv.$refs.tLoadScreen.startLoading();
    },
    methods: {
        retrieveTrending: async function() {
            var globv = this;
            try {
                let response = await axios.get('/api/trending', {
                    params: {
                        timeOffset: findTimeOffset()
                    }
                });

                // console.log(response);

                if (response && response.data) {
                    let trending = response.data;
                    globv.$refs.tFourchon.createChart(trending['ports'][0]);
                    globv.$refs.tLogs.updateInfo(trending['lastLogEntries']);
                    globv.$refs.tStatus.updateInfo(trending['lastStatusEntries']);
                    globv.$refs.tWellPlans.updateInfo(trending['latestWellPlans']);
                    globv.$refs.tDrillPermit.updateInfo(trending['latestDrillPermits']);
                    globv.$refs.tModifyPermit.updateInfo(trending['latestModifyPermits']);
                    setTimeout(globv.$refs.tLoadScreen.finishLoading, 100);
                }
            }
            catch (error) {
                globv.handleError(error);
            }
        },
        handleError: function() {
            var globv = this;
            // console.log(error, error.response);
            globv.$refs.tOops.showOops();
            setTimeout(globv.$refs.tLoadScreen.finishLoading, 100);
        }
    }
}
</script>

<style lang="scss">
.trendingContent {
    width: 90vw;
    min-width: 360px;
    max-width: 1100px;
    align-self: center;
    
    .chart {
        width: 90vw;
    }
}
</style>